import { render } from "./applicantsDataTable.vue?vue&type=template&id=65952fd6&ts=true"
import script from "./applicantsDataTable.vue?vue&type=script&lang=ts"
export * from "./applicantsDataTable.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__